module.exports = __webpack_public_path__ + "img/M1_BK_32.3931cc89.png";